import { Component, Input, ViewChild } from '@angular/core';
import { DxChartComponent } from 'devextreme-angular';

@Component({
    selector: 'ap-line-graph',
    templateUrl: './ap-line-graph.component.html'
})

export class APLineGraphComponent {
    @Input() dataSource: any[];
    @Input() title: string;
    @Input() valueAxisTitle: string;
    @Input() height: number = 400;
    @Input() isLegendVisible: boolean = false;

    @ViewChild(DxChartComponent, { static: false }) dxChart: DxChartComponent;

    customizeTooltip(arg: any) {
        return { text: "Year " + arg.argumentText + ": " + arg.valueText };
    }
}